angular.module("manager").factory("VehicleService", ["$http", "ENV", function ($http, ENV) {

	/**
	 * API
	 */
	var api = {
		RESOURCE_URI: "/manager/vehicles/",
		addVehicle: addVehicle,
		deleteVehicleById: deleteVehicleById,
		getVehicleById: getVehicleById,
		editVehicle: editVehicle,
		getVehicleWithFilters: getVehicleWithFilters,
		getEquipmentList: getEquipmentList,
		importCsv: importCsv
	};


	/**
	 * Récupérer le vehicle pour l'id passé en paramètre
	 * @param id
	 * @returns {HttpPromise}
	 */
	function getVehicleById(id) {
		return $http.get(ENV.API_URL + api.RESOURCE_URI + id);
	}

	/**
	 * Récupérer toutes les vehicules pour une compagnie.
	 * @returns {HttpPromise}
	 */
	function getVehicleWithFilters(postObject) {
		return $http.post(ENV.API_URL + api.RESOURCE_URI, postObject);
	}

	/**
	 * Mettre à jour un vehicule.
	 * @param v vehicule à mettre à jour
	 * @returns {*|HttpPromise}
	 */
	function editVehicle(v) {
		var vehicle = formatVehicle(v);
		vehicle.id = v.id;
		return $http.put(ENV.API_URL + api.RESOURCE_URI + v.id, vehicle);
	}

	/**
	 * Supprimer un vehicule.
	 *
	 * @param vehicleId l'ID du vehicule à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteVehicleById(vehicleId) {
		return $http.delete(ENV.API_URL + api.RESOURCE_URI + vehicleId);
	}

	/**
	 * Formattage de la date de mise en circulation
	 * @param date
	 * @returns {string}
	 */
	function getFormattedDate(date) {
		var year = date.getFullYear();
		var month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : "0" + month;
		var day = date.getDate().toString();
		day = day.length > 1 ? day : "0" + day;
		return year + "-" + month + "-" + day;
	}

	/**
	 * Ajouter un vehicule.
	 * @param vehicle le driver à ajouter.
	 * @returns {*|HttpPromise}
	 */
	function addVehicle(vehicle) {
		var newVehicle = formatVehicle(vehicle);
		return $http.put(ENV.API_URL + api.RESOURCE_URI, newVehicle);
	}

	/**
	 * Import CSV
	 * TODO
	 * @param vehicle
	 * @returns {HttpPromise}
	 */
	function importCsv(vehicle) {
		/*var fd = new FormData();
		fd.append('file', driver.file);
		fd.append('companyId', driver.company.id);

		return $http.post(ENV.API_URL + api.RESOURCE_URI + 'import/csv', fd, {
			transformRequest: angular.identity,
			headers: {'Content-Type': undefined}
		});*/
	}

	/**
	 * Récupère la liste des équipements disponible
	 * @returns {HttpPromise}
	 */
	function getEquipmentList() {
		return $http.get(ENV.API_URL + api.RESOURCE_URI + "vehicle_equipment");
	}

	/**
	 * Adapte le véhicule pour correspondre a l'objet backend
	 * @param vehicle
	 * @returns {{immat: *, model: *, brand: (string), circulationDate: string, category: *, standingCapacity: *, seatingCapacity: *, specialPlaceCapacity: *, vehicleEquipmentList: Array}}
	 */
	function formatVehicle(vehicle) {
		return {
			"immat": vehicle.immat,
			"model": vehicle.model,
			"brand": vehicle.brand,
			"circulationDate": getFormattedDate(new Date(vehicle.circulationDate)),
			"category": vehicle.category,
			"standingCapacity": vehicle.standingCapacity,
			"seatingCapacity": vehicle.seatingCapacity,
			"specialPlaceCapacity": vehicle.specialPlaceCapacity,
			"vehicleEquipmentList": vehicle.vehicleEquipmentList
		};
	}

	return api;

}]);
